<div class="form-group" [ngClass]="field.customClass">
  <label [for]="'field' + field.name">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? "*" : "" }}</span>
  </label>
  <input
    type="text"
    class="form-control"
    [class.is-invalid]="(control.touched || control.value) && control.errors"
    [class.is-valid]="control.touched && control.value !== undefined"
    ngbDatepicker
    #drange="ngbDatepicker"
    [name]="field.name"
    [placeholder]="field.inputPlaceholder || ''"
    [ngModel]="date"
    (ngModelChange)="updateDate($event)"
    (blur)="updateOnBlur($event)"
    (keydown)="updateOnKeydown($event)"
    (keyup)="updateOnKeyUp($event)"
    [id]="'field' + field.name"
    [attr.disabled]="disabled || null"
    [minDate]="minDate"
    [maxDate]="maxDate"
  />
  <button class="date-picker-toggle" (click)="drange.toggle()">
    <i class="mdi mdi-calendar"></i>
  </button>
</div>
